import * as age from "age-encryption";

/**
 * Generates a new age identity (private key) as a string.
 */
export async function generateIdentity(): Promise<string> {
  return await age.generateIdentity();
}

/**
 * Converts an age identity (private key) to a recipient (public key).
 */
export async function identityToRecipient(identity: string): Promise<string> {
  return await age.identityToRecipient(identity);
}

/**
 * Encrypts a secret value for one or more recipients. Returns an armored string.
 */
export async function encryptSecret(
  value: string,
  recipients: string[]
): Promise<string> {
  const encrypter = new age.Encrypter();
  for (const recipient of recipients) {
    encrypter.addRecipient(recipient);
  }
  const ciphertext = await encrypter.encrypt(value);
  return age.armor.encode(ciphertext);
}

/**
 * Decrypts an armored age-encrypted secret using the given identity (private key).
 */
export async function decryptSecret(
  armored: string,
  identity: string
): Promise<string> {
  const decrypter = new age.Decrypter();
  decrypter.addIdentity(identity);
  const decoded = age.armor.decode(armored);
  return await decrypter.decrypt(decoded, "text");
}
